<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    竹子林站<br>
站点介绍<br>
竹子林站位于深南大道南侧的绿地外缘，距深南大道道路边约20米，车站东端靠近上下广深高速公路的匝道，车站南侧有福田汽车站大楼和规划的客运中心。竹子林站建筑装修设计考虑与规划的交通中心协调一致，体现交通枢纽的特点：宽敞、舒适、方便。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:00	23:45	1号线	2分钟	4分40秒<br>
机场东	06:01	23:23	1号线	2分钟	4分40秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:06	23:43	1号线	3分45秒	5分45秒<br>
机场东	06:13	23:23	1号线	3分45秒	5分45秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:06	00:43	1号线	3分45秒	5分45秒<br>
机场东	06:13	00:23	1号线	3分45秒	5分45秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
深南大道南侧（东）、竹子林立交桥<br><br>
B1出入口:<br>
地铁竹子林车辆段、深圳人才园、深圳市社会保险基金管理局、深圳市地铁运营集团有限公司<br><br>
B2出入口:<br>
深南大道北侧、人行地道、深圳市交通运输局、国家税务总局深圳市福田区税务局、联泰大厦、东方银座美爵酒店<br><br>
C出入口:<br>
深南大道南侧、福田汽车站/福田交通枢纽中心<br><br>
D出入口:<br>
白石路<br><br>
E出入口:<br>
福安大厦<br><br>
公交换乘信息<br><br>
B1出入口:<br>
公交站名： 竹子林①<br>
高峰专线62、高峰专线119、高快巴士70、、高快巴士40、高峰专线40、223、234、235、M123（原123）、M488、NA1、N4、N6、21、26、101、113、204、222<br><br>
B1出入口:<br>
公交站名： 竹子林②<br>
M391、M392、M413、M433、M435、M447、M448、高峰专线31（M511）、高峰专线49、高快巴士25、320、338、M165、M183（原383）、M191<br><br>
B2出入口:<br>
公交站名： 竹子林①<br>
222、223、234、235、B968、M123（原123）、M488、N4、N6、高峰专线62、高峰专线119、21、26、101、113、204、70<br><br>
B2出入口:<br>
公交站名： 竹子林②<br>
M165、M433、M435、M448、高峰专线31（M511）、高峰专线49、高快巴士40、320、338、M183、M191、M391、M413、M312<br><br>
C出入口:<br>
公交站名： 福田公交枢纽站公交信息<br>
E4、M447、B611、322、高快16、303、假日专线、317、M417、旅游5号线、213、高峰专线18、高快巴士70号、M115、E6、E26、NE26、K578（左环）、K578（右环）、M414、M559、M521、M173、73、高快巴士26号、49、64、377、M392、M520、M137、M221、M213、高快巴士25、202<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>






